import createIcon from '../../createIcon';

/**
 * @component @name Escalator
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xNyA5SDE1LjNMMTAuMyAxOEg3QzYuMTcgMTggNS41IDE3LjMzIDUuNSAxNi41QzUuNSAxNS42NyA2LjE3IDE1IDcgMTVIOC43TDEzLjcgNkgxN0MxNy44MyA2IDE4LjUgNi42NyAxOC41IDcuNUMxOC41IDguMzMgMTcuODMgOSAxNyA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Escalator = createIcon('Escalator', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM17 9H15.3L10.3 18H7C6.17 18 5.5 17.33 5.5 16.5C5.5 15.67 6.17 15 7 15H8.7L13.7 6H17C17.83 6 18.5 6.67 18.5 7.5C18.5 8.33 17.83 9 17 9Z',
      key: '1iakxq',
    },
  ],
]);

export default Escalator;
